import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowRunButton',
    props: {
        id: null,
        full: { type: Boolean },
        title: null,
        disabled: { type: Boolean }
    },
    setup(__props) {
        library.add(faPlay);
        return { __sfc: true, faPlay, FontAwesomeIcon, BButton };
    }
});
